export const EVENTS = 'events'

export * from './get-events-batch'

export const eventsPaths = {
  filter: (account, query) => `${eventsPaths.events(account)}?${query}`,
  events: (account) => `${eventsPaths.account(account)}/events`,
  account: (idenitity) => `/v1/accounts/${idenitity}`,
}
